import { render, staticRenderFns } from "./HistoryListComponent.vue?vue&type=template&id=0ce414ed&scoped=true&"
import script from "./HistoryListComponent.vue?vue&type=script&lang=js&"
export * from "./HistoryListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce414ed",
  null
  
)

export default component.exports